import type { Candle } from "../types";

/**
 * Whether a round's candles carry volume worth charting (GRA-133). Most
 * rounds today have no `volume` field at all (the data pipeline does not
 * emit one), and a KLineChart VOL pane built from that data is not empty,
 * it is a pane full of zero-height bars: it occupies space and shows
 * nothing. A round only earns the pane when at least one candle has a
 * defined, positive volume.
 */
export function hasMeaningfulVolume(candles: Candle[]): boolean {
  return candles.some((c) => typeof c.volume === "number" && c.volume > 0);
}
